'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_ClientAppDocumentWithMetadata(doc, meta, issuerId, maybeIssuerLogo, recipientId, versions) {
  this.pL = null;
  this.Fs = null;
  this.XS = null;
  this.XT = null;
  this.XU = null;
  this.LF = null;
  this.pL = doc;
  this.Fs = meta;
  this.XS = issuerId;
  this.XT = maybeIssuerLogo;
  this.XU = recipientId;
  this.LF = versions;
}
export { $c_Lapp_data_ClientAppDocumentWithMetadata as $c_Lapp_data_ClientAppDocumentWithMetadata };
$p = $c_Lapp_data_ClientAppDocumentWithMetadata.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_ClientAppDocumentWithMetadata;
/** @constructor */
function $h_Lapp_data_ClientAppDocumentWithMetadata() {
}
export { $h_Lapp_data_ClientAppDocumentWithMetadata as $h_Lapp_data_ClientAppDocumentWithMetadata };
$h_Lapp_data_ClientAppDocumentWithMetadata.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_ClientAppDocumentWithMetadata)) {
    var x = this.pL;
    var x$2 = x$0.pL;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.Fs;
      var x$4 = x$0.Fs;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.XS;
      var x$6 = x$0.XS;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.XT;
      var x$8 = x$0.XT;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.XU;
      var x$10 = x$0.XU;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.LF;
      var x$12 = x$0.LF;
      return ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 6;
});
$p.t = (function() {
  return "ClientAppDocumentWithMetadata";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.pL;
      break;
    }
    case 1: {
      return this.Fs;
      break;
    }
    case 2: {
      return this.XS;
      break;
    }
    case 3: {
      return this.XT;
      break;
    }
    case 4: {
      return this.XU;
      break;
    }
    case 5: {
      return this.LF;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "doc";
      break;
    }
    case 1: {
      return "meta";
      break;
    }
    case 2: {
      return "issuerId";
      break;
    }
    case 3: {
      return "maybeIssuerLogo";
      break;
    }
    case 4: {
      return "recipientId";
      break;
    }
    case 5: {
      return "versions";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_ClientAppDocumentWithMetadata(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ji)));
}
export { $isArrayOf_Lapp_data_ClientAppDocumentWithMetadata as $isArrayOf_Lapp_data_ClientAppDocumentWithMetadata };
var $d_Lapp_data_ClientAppDocumentWithMetadata = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_ClientAppDocumentWithMetadata, "app.data.ClientAppDocumentWithMetadata", ({
  ji: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_ClientAppDocumentWithMetadata as $d_Lapp_data_ClientAppDocumentWithMetadata };
//# sourceMappingURL=app.data.-Client-App-Document-With-Metadata.js.map
